import React, { Component } from 'react';
import PropTypes from 'prop-types';


import DateTime from "components/Display/ViewDateTime";
import BatchStatus from "./BatchStatus";

const BatchTable = ({ user, list, onClick }) => {
  if (Object.keys(user).length === 0){
    return (<div/>);
  }
  return (
    <div className="calc-setting-table ">
      <span>Pakkar sendir af notanda {user.sentByUsername}</span>
      <table className="table">
        <colgroup>
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colSpan="10" className="text-left calc-setting-table-header">Sendir pakkar</th>
        </tr>
        <tr>
          <th className="text-left">B.ID</th>
          <th className="text-left">Sending byrjar</th>
          <th className="text-left">Gildir til</th>
          <th className="text-left">Staða</th>
          <th className="text-left">Staða uppf.</th>
          <th className="text-left">Uploaded#</th>
          <th className="text-left">Valid#</th>
          <th className="text-left">Invalid#</th>
          <th className="text-left">Re.</th>
          <th className="text-left">Dereg.</th>

        </tr>
        </thead>
        <tbody>
        {list.map(function(item,i){
          return(
            <tr key={i}>
              <td className="text-left"><a onClick={(e)=> onClick(e, item)}>{item.batchID.toString()}</a></td>
              <td className="text-left"><DateTime data={item.startTime}/></td>
              <td className="text-left"><DateTime data={item.validUntil}/></td>
              <td className="text-left"><BatchStatus data={item.batchStatusID}/> </td>
              <td className="text-left"><DateTime data={item.lastStatusUpdate}/></td>
              <td className="text-center">{item.totalUploadedRecords.toString()} </td>
              <td className="text-center">{item.totalValidRecords.toString()} </td>
              <td className="text-center">{item.totalInvalidRecords.toString()} </td>
              <td className="text-center">{item.registered.toString()} </td>
              <td className="text-center">{item.deregister.toString()} </td>
            </tr>);
        })}
        </tbody>
      </table>
    </div>
  );
};

BatchTable.propTypes = {
  user : PropTypes.object,
  list: PropTypes.array,
  onClick : PropTypes.func
};

export default BatchTable;



// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Batch/BatchTable.js